<template lang="pug">
.theme.public.skin--(:class='themeNs')
  //component.theme(:is='theme')
  keep-alive
    component.layout(:is='layout')
      component.module(:is='module()', :class='className' ref='currentModule')
</template>

<script>
/* eslint no-multi-spaces: 0 */

//
import Themes            from '@/components/Themes'
import Layouts           from '@/components/Layouts'
import Components        from '@/components/_modules'

import notImplemented    from '@/components/GeneralViews/NotImplemented.vue'
import legacyModule      from '@/components/LegacyContainer'
import loadingIndicators from '@/core/loading-indicators'

export default {
  created() {
    Themes.app[this.themeNs]()
  },

  computed: {
    // THEME
    themeNs: () => Themes.domains[global.location.hostname] || Themes.domains['default'],
    theme() {
      return Themes.app[this.themeNs]
    },

    // LAYOUT
    layout() {
      const app    = this._self
      const route  = app.$route
      const module = Components[route.params.page || route.name]

      if (module && module.layout) {
        return Layouts[module.layout].default
      } else {
        // return Layouts.default
        return Layouts.other.default
      }
    }
  },

  data() {
    return {
    // MODULE
      module() {
        const app    = this._self
        const route  = app.$route
        var module   = Components[route.params.page || route.name]

        if (module && module.pack && route.params.section) {
          module = Components[route.params.section]
        }

        if (route.params.namespace === 'i') {
          return legacyModule
        }

        if (module) {
          // Hook into before/after loading lazy modules
          // for handling loading indicators
          module
            .on('afterLoad', function () {
              loadingIndicators.hook.stop.call(app)

              if (module.legacy) {
                app.className = 'legacy'
              }

              // If module has Grid, apply class
              /* if (this.components && this.components.Grid) {
                if (module.legacy) {
                  app.className = 'legacy grid'
                } else {
                  app.className = 'grid'
                }
              } */
            })
            .on('beforeLoad', function () {
              loadingIndicators.hook.start.call(app)
            })

          return module.module || module
        } else {
          return notImplemented
        }
      },

      className: ''
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Layouts/shell/public.vue